import measuretext from "../../../../assets/images/docs/measuretext.jpg";
import * as React from 'react';
export default {
  measuretext,
  React
};